import * as React from 'react';
import Link, { LinkProps } from '@material-ui/core/Link';
import { useDispatch } from 'react-redux';
import { routesMap } from 'routes';

interface Props extends LinkProps {
  to: {
    type: Nl.RouteMapType;
    payload?: any;
  };
}

const InternalLink = React.forwardRef(
  (
    { to, color, children, ...linkProps }: Props,
    _: React.ForwardedRef<unknown>,
  ) => {
    const dispatch = useDispatch();
    let href = routesMap[to.type]?.path as string;
    if (to.payload?.uuid) {
      href = href?.replace(':uuid', to.payload.uuid);
    }
    return (
      <Link
        color={color || 'inherit'}
        href={href}
        onClick={(event: React.SyntheticEvent) => {
          event.preventDefault();
          dispatch(to);
        }}
        {...linkProps}
      >
        {children}
      </Link>
    );
  },
);

export default InternalLink;
